import { Backdrop, CircularProgress, Grid, Paper, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { isLoading, selectErrMsg, selectMsg,  setErrMsg, setMsg } from "../redux/UserSlice";
import { ActionButton } from "../components/ActionButton/ActionButton";
import { linkStyle } from "../theme";
import { sendRegNum } from "../redux/UserAPI";


export function PasswordReminder() {
  const [regNum, setRegNum] = React.useState<number | undefined>(undefined);
  const [err, setErr] = React.useState<string | null>(null);
  const dispatch = useAppDispatch();
  const msg = useAppSelector(selectMsg);
  const err_msg = useAppSelector(selectErrMsg);
  const isLoadinguserslice = useAppSelector(isLoading)
  const history = useHistory();
  const { t } = useTranslation();
  const regNum_regex = /^[0-9]{7}$/;

  useEffect(() => {
    if (msg) dispatch(setMsg(null));
    if (err_msg) dispatch(setErrMsg(null));
  }, []);

  useEffect(() => {
    if (!msg) {
      return;
    } else {
      history.push("/");
    }
  }, [msg]);

  const submit = () => {
    const err_msg = "Please enter a valid Registration Number";
    if (!regNum || !regNum_regex.test(regNum.toString())) return setErr(err_msg);

    dispatch(sendRegNum(regNum as number));
  };

  return (
    <Grid
    container
    direction="row"
    justifyContent="center"
    alignContent={"flex-start"}
    alignItems="center"
    spacing={2}
    sx={{  mt: '13em', " @media (minWidth:400px)": { padding: 10 }, minHeight: window.innerHeight }}
  >
      <Backdrop
              sx={{
                zIndex: 8000,
                color: "#fff",
              }}
              open={isLoadinguserslice}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
    <Grid
      item

      xs={11} md={5}

      sx={{ padding: "0px, 0px", " @media (minWidth:400px)": { padding: "0px, 20px" } }}
    >
      <Paper sx={{ padding: "0px, 0px", "@media (minWidth:400px)": { padding: "0px, 20px" } }}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          style={{ padding: '3em' }}
        >
              <Grid lg={12} item style={{}}>
                <Typography variant="h6" align="center">
                Enter your registration number below and we will send you a link to reset your password.
                </Typography>
              </Grid>
              <Grid xs={8} sm={8} md={8} lg={8} xl={8} item style={{ margin: "0 auto" }}>
                <hr style={{ height: "1px", background: "black", width: "100%" }}></hr>
              </Grid>
              <Grid lg={7} sm={7} item >
                <TextField
                sx={{"& .MuiFormHelperText-root": {textAlign: "center"}}}
                  value={regNum}
                  onChange={(e: any) => {
                    setErr(null);
                    if (!/^[0-9]*$/.test(e.target.value)) {
                      return
                      const msg = t("validation.regNum_digits");
                      return setErr(msg);
                    }
                    if (/^\d{8}$/.test(e.target.value)) {
                      return
                      const msg = t("validation.regNum_digits_count");
                      return setErr(msg);
                    }
                    setRegNum(e.target.value);
                  }}
                  required
                  fullWidth
                  helperText="Enter your Registration Number"
                />
              </Grid>
              <Grid  xs={12} item style={{}}>
                <ActionButton action={submit} name="Send" local_error={err} />
              </Grid>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                style={{ padding: 20 }}
              >
                <Grid lg={8} item style={{}}>
                  <Link style={linkStyle} to="/">
                  Go Back
                  </Link>
                </Grid>
                <Grid lg={8} item style={{}}>
                  <Link style={linkStyle} to="/registration">
               Create an Account
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
     
      </Grid>
    </Grid>
  );
}


